module.exports = __webpack_public_path__ + "img/m-banner-kfkmkuef-pl-PL.ac2f9e51.png";